"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTranslationStore = void 0;
const pinia_1 = require("pinia");
const Filters_1 = __importDefault(require("./Filters"));
const _locales_1 = __importDefault(require("../../common/i18n/_locales"));
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useTranslationStore = (0, pinia_1.defineStore)("translationStore", {
    state: () => ({
        languages: _locales_1.default,
        workingLanguages: [],
        translations: [],
        filters: new Filters_1.default(),
        totalItems: 0,
        totalPages: 0,
    }),
    getters: {},
    actions: {
        loadByFilters(router) {
            let filters = this.filters;
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({
                    name: "admin_translations_api",
                    query: filters.createQuery(),
                }).href)
                    .then((response) => {
                    this.translations = response["hydra:member"];
                    this.totalItems = response["hydra:totalItems"];
                    this.totalPages = Math.ceil(this.totalItems / this.filters.itemsPerPage);
                    resolve(response["hydra:member"]);
                })
                    .catch((err) => {
                    reject(err);
                });
            });
        },
        updateTranslation(router, item) {
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: "admin_translations_api" }).href +
                    "/" +
                    item.id, { method: "PATCH", body: JSON.stringify(item) })
                    .then((response) => {
                    resolve(response);
                })
                    .catch((err) => {
                    reject(err);
                });
            });
        },
        writeOutTranslations(router) {
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({
                    name: "admin_translations_api_write_out_translations",
                }).href, { method: "POST" })
                    .then((response) => {
                    resolve(response);
                })
                    .catch((err) => {
                    reject(err);
                });
            });
        },
    },
});
